import { useAuth } from '../contexts/AuthContext';

export const useAdminStatus = () => {
  const { isAuthenticated, isAdmin, isSuperAdmin, userRole } = useAuth();

  return {
    isAdmin: isAuthenticated && isAdmin,
    isSuperAdmin: isAuthenticated && isSuperAdmin,
    role: userRole,
    isLoading: false, // No longer needed since we get this from JWT
  };
};
